const getEnvValue = (env: string | undefined) => env || ''

export { getEnvValue }
